import React, { useEffect } from 'react';

import PropTypes from 'prop-types';

import SafelyParseHTML from '@src/services/renderEditorText';

import '../content.scss';

export const Content = (props) => {
    const { content } = props;
    useEffect(() => {
        const loadScript = (src, onLoad) => {
            const script = document.createElement('script');
            script.src = src;
            script.async = false;
            script.onload = onLoad;
            document.head.appendChild(script);
        };

        loadScript('https://code.jquery.com/jquery-3.5.1.slim.min.js', () => {
            loadScript('https://cdn.jsdelivr.net/npm/bootstrap@4.6.0/dist/js/bootstrap.bundle.min.js');
        });
    }, []);

    return (
        <div className="post-content-container pb-3">
            <div>{SafelyParseHTML(content)}</div>
        </div>
    );
};

Content.propTypes = {
    content: PropTypes.string,
};

